import Vue from 'vue'
import Router from 'vue-router'
import { auth, metadb } from '../firebase'
import store from '../store'

// Containers
import Full from '@/layouts/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Interactions from '@/views/Interactions'
import Interaction from '@/views/Interaction'
import InteractionsRT from '@/views/InteractionsRT'
import InteractionMenu from '@/views/InteractionMenu'
import VideoCall from '@/views/VideoCall'
import Users from '@/views/Users'
import Data from '@/views/Data'
import Graph from '@/views/Graph'
import Campaigns from '@/views/Campaigns'
import Campaign from '@/views/Campaign'
import CRM from '@/views/CRM'
import Manual from '@/views/Manual'
import IntentsList from '@/views/Intents/IntentsList'

// Custom CRM
import CRMAppointment from '@/views/CRM/appointment'
import CRMMotorInsurance from '@/views/CRM/motor-insurance'
import CRMAccountOpening from '@/views/CRM/accountOpening'
import CRMTM from '@/views/CRM/tm'

// Analytics
// import InteractionsAnalytics from '@/views/Analytics/InteractionsAnalytics'
// import TopicsAnalytics from '@/views/Analytics/TopicsAnalytics'
import JobListing from '@/views/Analytics/JobAnalytics'
import VisitorTimeline from '@/views/Analytics/VisitorTimeline'
import DailyVisitor from '@/views/Analytics/DailyVisitor'
import InteractionsTimeline from '@/views/Analytics/InteractionsTimeline'
import DailyInteractions from '@/views/Analytics/DailyInteractions'
import IntentsPie from '@/views/Analytics/IntentsPie'
import IntentsTreemap from '@/views/Analytics/IntentsTreemap'
import IntentsListAnalytic from '@/views/Analytics/IntentsList'
import Fallback from '@/views/Fallback'
import NotFound from '@/views/404'

// Pages
import Login from '@/views/Login'
import Logout from '@/views/Logout'

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // redirects all paths to login to mask functional links
    {
      path: '*',
      redirect: '/login',
    },
    {
      path: '/',
      name: 'Home',
      component: Full,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: '/interactions',
          name: 'Interactions',
          component: {
            render (c) { return c('router-view') },
          },
          children: [{
            path: '/interactions/live',
            name: 'Live',
            component: InteractionsRT,
          }, {
            path: '/interactions/supervisor',
            name: 'Supervisor',
            component: Interactions,
            props: { boss: true },
          }, {
            path: '/interactions/historical',
            name: 'Historical',
            component: Interactions,
          }, {
            path: '/interactions/:userId',
            name: 'Interaction',
            component: Interaction,
          }],
        },
        {
          path: '/interactionsMenu',
          name: 'Interactions Menu',
          component: InteractionMenu,
        },
        {
          path: '/videoCall',
          name: 'Video Call',
          component: VideoCall,
        },
        {
          path: '/customers',
          name: 'Customers',
          component: Users,
        },
        {
          path: '/chatflow',
          name: 'Chat Flow (Beta)',
          component: Data,
        },
        {
          path: '/graph',
          name: 'Graph',
          component: Graph,
        },
        {
          path: '/broadcast',
          // name: 'Broadcasts',
          component: {
            render (c) { return c('router-view') },
          },
          children: [{
            path: '',
            name: 'List of Broadcasts',
            component: Campaigns,
          }, {
            path: '/broadcast/:Id',
            name: 'Broadcast',
            component: Campaign,
          }],
        },
        {
          path: '/studio',
          name: 'NL Studio',
          component: IntentsList,
          // children: [{
          //   path: '',
          //   name: 'Home',
          //   component: IntentsHome
          // }, {
          //   path: '/Dialog/IntentsList',
          //   name: 'List of Intents',
          //   component: IntentsList
          // }, {
          //   path: '/Dialog/IntentsManager',
          //   name: 'Intents Management',
          //   component: IntentManager
          // }]
        },
        {
          path: '/Analytics',
          name: 'Analytics',
          component: {
            render (c) { return c('router-view') },
          },
          children: [{
            path: '/Analytics/VisitorTimeline',
            name: 'Visitor Timeline',
            component: VisitorTimeline,
          }, {
            path: '/Analytics/DailyVisitor',
            name: 'Daily Visitor',
            component: DailyVisitor,
          }, {
            path: '/Analytics/InteractionsTimeline',
            name: 'Interactions Timeline',
            component: InteractionsTimeline,
          }, {
            path: '/Analytics/DailyInteractions',
            name: 'Daily Interactions',
            component: DailyInteractions,
          }, {
            path: '/Analytics/IntentsPie',
            name: 'Intents Pie',
            component: IntentsPie,
          }, {
            path: '/Analytics/IntentsTreemap',
            name: 'Intents Treemap',
            component: IntentsTreemap,
          }, {
            path: '/Analytics/IntentsList',
            name: 'Intents List',
            component: IntentsListAnalytic,
          }],
        },
        {
          path: '/crm',
          redirect: '/crm/chatbot',
        },
        {
          path: '/crm/chatbot',
          name: 'CRM',
          component: CRMTM,
        },
        {
          path: '/crm/accountOpening',
          name: 'Account Opening',
          component: CRMAccountOpening,
        },
        {
          path: '/crm/appointment',
          name: 'Appointment',
          component: CRMAppointment,
        },
        {
          path: '/crm/motor-insurance',
          name: 'Motor Insurance',
          component: CRMMotorInsurance,
        },
        {
          path: '/crm/default',
          name: 'Task Reporting',
          component: CRM,
        },
        {
          path: '/crm/JobListing',
          name: 'Job Listing',
          component: JobListing,
        },
        {
          path: '/manual',
          name: 'User Manual',
          component: Manual,
        },
        {
          path: '/fallback',
          name: 'Fallback',
          component: Fallback,
        },
        { path: '/404',
          name: 'Error 404',
          component: NotFound,
        },
        {
          path: '/logout',
          name: 'Logout',
          component: Logout,
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
  ],
})

router.beforeEach((to, from, next) => {
  let currentUser = auth.currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let userEmail = currentUser && currentUser.email
  let userAccessInformation = {}

  let prom = new Promise((resolve, reject) => {
    metadb.ref('users').orderByChild('email').equalTo(userEmail).once('value').then((datasnapshot) => {
      datasnapshot.forEach((child) => {
        if (child.val().email == userEmail) {
          userAccessInformation = child.val()
          resolve(userAccessInformation)
        }
      })
    })
  })

  if (requiresAuth && !currentUser) next('login')
  else if (requiresAuth && currentUser) {
    if (Object.keys(store.state.profile).length === 0) {
      prom.then((res) => {
        // console.log(res)
        store.dispatch('setProfile', res)
        next()
      })
    } else {
      // console.log('state is defined')
      next()
    }
    // console.log(userEmail, userAccessInformation)
  } else if (!requiresAuth && currentUser && to.redirectedFrom) next('404')
  else if (!requiresAuth && currentUser) next('/')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js